import { Skeleton } from "@mui/material";
import { BlockCard } from "../primitives";
import styles from "./style.module.scss";

/* The chart viewBox, copied from TrendChart so the placeholder curve lands
   where the real line will. */
const VIEW_W = 600;
const VIEW_H = 200;

/** A generic rising curve - it only has to read as "a line chart goes here". */
const PLACEHOLDER_LINE =
  "M0,158 C60,150 96,126 150,124 C204,122 240,162 300,116 " +
  "C360,70 396,96 450,76 C504,56 552,44 600,34";

interface ReadingTrendsBlockSkeletonProps {
  /** X labels expected, so the axis reserves the same room. */
  tickCount?: number;
  className?: string;
}

function ReadingTrendsBlockSkeleton({
  tickCount = 5,
  className,
}: ReadingTrendsBlockSkeletonProps) {
  return (
    <BlockCard
      title={<Skeleton variant="text" width={200} height={26} />}
      headerTight
      className={className}
      actions={
        <Skeleton
          variant="rounded"
          width={150}
          height={34}
          sx={{ borderRadius: "999px" }}
        />
      }
    >
      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <Skeleton variant="rounded" width={18} height={3} />
          <Skeleton variant="text" width={92} height={18} />
          <Skeleton variant="text" width={42} height={18} />
        </div>
      </div>

      <div className={styles.chartGrid}>
        <div className={styles.yAxis}>
          {Array.from({ length: 6 }).map((_, index) => (
            <span key={index} style={{ top: `${index * 20}%` }}>
              <Skeleton variant="text" width={22} height={12} />
            </span>
          ))}
        </div>
        <div className={styles.plot}>
          <svg
            viewBox={`0 0 ${VIEW_W} ${VIEW_H}`}
            preserveAspectRatio="none"
            className={styles.svg}
          >
            <path
              d={`${PLACEHOLDER_LINE} L${VIEW_W},${VIEW_H} L0,${VIEW_H} Z`}
              className={styles.ghostArea}
            />
            <path d={PLACEHOLDER_LINE} className={styles.ghostLine} />
          </svg>
        </div>
      </div>

      <div className={styles.chartGrid}>
        <div />
        <div className={styles.xAxis}>
          {Array.from({ length: tickCount }).map((_, index) => (
            <span
              key={index}
              style={{
                left: `${(index / Math.max(1, tickCount - 1)) * 100}%`,
                transform:
                  index === 0
                    ? "translateX(0)"
                    : index === tickCount - 1
                    ? "translateX(-100%)"
                    : "translateX(-50%)",
              }}
            >
              <Skeleton variant="text" width={58} height={12} />
            </span>
          ))}
        </div>
      </div>
    </BlockCard>
  );
}

export default ReadingTrendsBlockSkeleton;
